import {Map, Record} from 'immutable';

import generateUUID from 'web-app/util/uuid';
import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import type * as Types from './types';

export interface DialogStateProps {
    dialogs: Map<string, Types.DialogProps<any>>;
}
export class DialogState extends Record<DialogStateProps>({
    dialogs: Map(),
}) {}

export default makeReducer<DialogState>(
    [
        match(Actions.show, (state, {payload}) =>
            state.merge({
                dialogs: state.dialogs.set(generateUUID(), payload.dialog),
            }),
        ),
        match(Actions.hide, (state, {payload}) =>
            state.merge({
                dialogs: state.dialogs.delete(payload.id),
            }),
        ),
    ],
    new DialogState(),
);
